<template>
    <v-alert
            :type="notification.type"
            :class="{'pointer': notification.to}"
            dismissible
            @click="navigate">
        {{ notification.message }}
    </v-alert>
</template>


<script>
export default {
  name: "NotificationListItem",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigate() {
      this.$router.push({name: this.notification.to});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "notification-list-item";
</style>